import { apiService } from "./index";

// Strip null, undefined, empty string, and empty array values
// so Rails doesn't receive params that trigger unintended filters.
// Backbone only sent non-default values; we must do the same.
function cleanParams(params) {
  const cleaned = {};
  for (const [key, value] of Object.entries(params)) {
    if (value == null) continue;
    if (value === "") continue;
    if (Array.isArray(value) && value.length === 0) continue;
    cleaned[key] = value;
  }
  return cleaned;
}

const searchService = {
  search(params) {
    return apiService.post("/search", cleanParams(params));
  },

  getResult(id) {
    return apiService.get(`/search/${id}`);
  },

  getAgency(agencyId, { siteNumber, programSiteId } = {}) {
    const params = new URLSearchParams();
    if (siteNumber) params.set("site_number", siteNumber);
    if (programSiteId) params.set("program_site_id", programSiteId);
    const qs = params.toString();
    return apiService.get(`/agencies/${agencyId}${qs ? `?${qs}` : ""}`);
  },

  getArticles(programSiteId) {
    return apiService.get(`/articles/for/${programSiteId}`);
  },

  getServiceAreas(programSiteId) {
    return apiService.get(`/service_areas/for/${programSiteId}`);
  },

  shareResult({ email, client, comments, phone, replyToMe, programSiteId, result, agency }) {
    return apiService.post("/share/resource", {
      ...result,
      email,
      client,
      comments,
      phone,
      reply_to_me: replyToMe,
      program_site_id: programSiteId,
      current_url: `/search/${programSiteId}`,
      agency: agency || {},
    });
  },

  sendReferralEmail(payload) {
    return apiService.post("/referral_emails", payload);
  },

  trackActivity({ action, name, site_name, program_at_site_number }) {
    // Fire-and-forget: defer to avoid blocking critical page requests
    // (especially important with single-threaded servers in CI/test)
    setTimeout(() => {
      apiService.post("/activity_logs", {
        action,
        name,
        site_name,
        program_at_site_number,
      }).catch(() => {});
    }, 0);
  },
};

export { searchService };
